import { ORGANIC_STATES } from 'utils/GlobalVariables';
import { sortByCAPCategory } from './cultureSort';

export const getSeasonFilter = (positionInList, totalInList) => {
  if (totalInList === 1) return 'single';
  if (positionInList === 0) return 'first';
  return 'second';
};

export const getFilteredCultures = (seasonFilter, cultures, currentOrganicState) => {
  const culturesList = Array.isArray(cultures) ? cultures : cultures ? [cultures] : [];
  let filtered = culturesList?.filter(
    (culture) =>
      culture.customizedFor === 'both' ||
      (culture.customizedFor === ORGANIC_STATES.organic &&
        currentOrganicState === ORGANIC_STATES.organic) ||
      (culture.customizedFor === ORGANIC_STATES.organic &&
        currentOrganicState === ORGANIC_STATES.conversion) ||
      (culture.customizedFor === ORGANIC_STATES.conventional &&
        currentOrganicState === ORGANIC_STATES.conventional),
  );

  switch (seasonFilter) {
    case 'single':
      filtered = filtered?.filter((c) => c.type === 'main');
      break;
    case 'first':
      filtered = filtered?.filter(
        (c) =>
          (c.type === 'main' && (c.season === 'winter' || c.season === 'spring')) ||
          (c.type === 'intermediate' && c.season === 'winter'),
      );
      break;
    case 'second':
      filtered = filtered?.filter(
        (c) => (c.type === 'main' || c.type === 'intermediate') && c.season === 'summer',
      );
      break;
  }
  const result = filtered?.sort(sortByCAPCategory) || [];
  return result;
};
